import {
  AnalyticsService,
  ConsentService,
  TLanguage,
  prodFrontendUrl,
} from '@geovelo-frontends/commons';

import { environment } from '../environment';

import i18n from './i18n';
import theme from './theme';

AnalyticsService.init(environment.amplitude.apiKey, { requireConsent: true });

ConsentService.init({
  language: i18n.language as TLanguage,
  privacyUrl: `${prodFrontendUrl}/${i18n.language === 'fr' ? 'fr' : 'en'}/cookies-policy/`,
  theme: {
    fontFamily: theme.typography.fontFamily || 'sans-serif',
    primaryColor: theme.palette.primary.main,
    primaryContrastText: theme.palette.primary.contrastText,
    primaryDarkColor: theme.palette.primary.dark,
  },
});
